import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import "./EditCard.css";

export default function EditCard() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("Bedroom");
  const [type, setType] = useState("Bed");
  const [price, setPrice] = useState("");
  const [material, setMaterial] = useState("");
  const [color, setColor] = useState("");
  const [active, setActive] = useState(true);
  const [image, setImage] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Convert image to Base64
  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  useEffect(() => {
    const loadCard = async () => {
      try {
        const snap = await getDoc(doc(db, "workCards", id)); // ✅ FIXED
        if (!snap.exists()) {
          alert("Card not found");
          navigate(-1);
          return;
        }

        const data = snap.data();
        setTitle(data.title || "");
        setDescription(data.description || "");
        setCategory(data.category || "Bedroom");
        setType(data.type || "Bed");
        setPrice(data.price || "");
        setMaterial(data.material || "");
        setColor(data.color || "");
        setActive(data.active !== undefined ? data.active : true);
        setImage(data.image || "");
      } catch (err) {
        console.error(err);
        alert("Failed to load card");
      } finally {
        setLoading(false);
      }
    };

    loadCard();
  }, [id, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    try {
      setSaving(true);

      let finalImage = image;
      if (imageFile) {
        if (imageFile.size > 2 * 1024 * 1024) {
          alert("Image must be less than 2MB");
          setSaving(false);
          return;
        }
        finalImage = await convertToBase64(imageFile);
      }

      await updateDoc(doc(db, "workCards", id), { // ✅ FIXED
        title: title.trim(),
        description: description.trim(),
        category,
        type,
        price: Number(price) || 0,
        material: material.trim(),
        color: color.trim(),
        active,
        image: finalImage,
      });

      navigate(-1); // më mirë UX se path hardcoded
    } catch (err) {
      console.error(err);
      alert("Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p style={{ textAlign: "center" }}>Loading...</p>;

  return (
    <div className="add-card-container">
      <button onClick={() => navigate(-1)} className="back-btn">
        ⬅ Back
      </button>

      <h1>Edit Card</h1>

      <form onSubmit={handleSubmit} className="add-card-form">
        <input
          type="text"
          placeholder="Card Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <textarea
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />

        <input
          type="number"
          placeholder="Price (€)"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />

        <input
          type="text"
          placeholder="Material"
          value={material}
          onChange={(e) => setMaterial(e.target.value)}
        />

        <input
          type="text"
          placeholder="Color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
        />

        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option>Bedroom</option>
          <option>Kids Bedroom</option>
          <option>Decoration</option>
          <option>Living Room</option>
        </select>

        <select value={type} onChange={(e) => setType(e.target.value)}>
          <option>Bed</option>
          <option>TV Panel</option>
          <option>TV Stand</option>
          <option>Dresser with Mirror</option>
          <option>Desk</option>
        </select>

        <label className="active-toggle">
          <input
            type="checkbox"
            checked={active}
            onChange={(e) => setActive(e.target.checked)}
          />
          Active
        </label>

        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImageFile(e.target.files[0])}
        />

        <div className="image-preview">
          {image || imageFile ? (
            <img
              src={imageFile ? URL.createObjectURL(imageFile) : image}
              alt="Preview"
            />
          ) : (
            <p>No image</p>
          )}
        </div>

        <button type="submit" disabled={saving}>
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </form>
    </div>
  );
}
